import {Part} from "../part";
import {wallsThumbnail} from "../assets";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import store from "../../../../store";
import Backsplash from "../subparts/walls/backsplash";
import LeftWall from "../subparts/walls/leftWall";
import RightWall from "../subparts/walls/rightWall";
import CenterWall from "../subparts/walls/centerWall";
import FrontWall from "../subparts/walls/frontWall";
import PonyWall from "../subparts/walls/ponyWall";
import SplitWall from "../subparts/walls/splitWall";

export default class Walls extends Part {
  static id = 'Walls';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Walls';
    this.partThumbnail = wallsThumbnail;
    this.translateId = "visualizer.kitchen.walls";

    // related items
    this.leftWall = null;
    this.rightWall = null;
    this.centerWall = null;
    this.frontWall = null;
    this.ceiling = null;
    this.backsplash = null;
    this.splitWall = null;
    this.relatedGroupNames = ["Backsplash", "Left Wall", "Right Wall", "Center Wall", "Front Wall", "Pony Wall",
      "Split Wall"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Backsplash":
      case "backsplash":
        relatedItemName = "backsplash";
        RelatedItemClass = Backsplash;
        break;
      case "Left Wall":
        relatedItemName = "leftWall";
        RelatedItemClass = LeftWall;
        break;
      case "Right Wall":
        relatedItemName = "rightWall";
        RelatedItemClass = RightWall;
        break;
      case "Center Wall":
        relatedItemName = "centerWall";
        RelatedItemClass = CenterWall;
        break;
      case "Front Wall":
        relatedItemName = "frontWall";
        RelatedItemClass = FrontWall;
        break;
      case "Pony Wall":
        relatedItemName = "ponyWall";
        RelatedItemClass = PonyWall;
        break;
      case "Split Wall":
        relatedItemName = "splitWall";
        RelatedItemClass = SplitWall;
        break;
      // case "Shower Shadow":
      //   if (
      //     dbFeature.displayName.includes("Shower Shadow - Divider Wall")
      //     || dbFeature.displayName.includes("Shower Shadow - EX L")
      //     || dbFeature.displayName.includes("Shower Shadow - EX R")
      //     || dbFeature.displayName.includes("Shower Shadow - Popout")
      //     || dbFeature.displayName.includes("Shower Shadow - Pony Wall")
      //   ) {
      //     relatedItemName = "shadows";
      //     RelatedItemClass = Shadow;
      //   }
      //   break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => this.filterRelatedItem(item, withHidden))
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  recoverPrevioslySelected(activeRelatedPart) {
    const {activeQuoteIndex} = store.getState().quotesState;
    this.relatedItems.forEach(relatedItem => {
      if (relatedItem.partId !== activeRelatedPart.partId && relatedItem.activeFeatureBeforeAllWalls) {
        if (relatedItem.activeFeatureBeforeAllWalls === "placeholder") {
          relatedItem.placeholderChanged = false;
          relatedItem.firstClick[activeQuoteIndex] = false;
        } else if (!relatedItem.selectedByUser) {
          relatedItem.activeFeatureBeforeAllWalls.clickFromAllWalls();
        }
      }
    });
  }

}
